import React, { useMemo } from 'react';
import { RoundedBox } from '@react-three/drei';
import * as THREE from 'three';

export type BeveledPanelProps = {
  size: [number, number, number];
  material: THREE.Material;
  position?: [number, number, number];
  rotation?: [number, number, number];
  radius?: number;
  /** RoundedBox segment count — 3 gives smoother industrial curves. */
  smoothness?: number;
  castShadow?: boolean;
  receiveShadow?: boolean;
};

/** Subtle industrial bevel — reference-style soft edges (1–2 segments). */
export const BeveledPanel: React.FC<BeveledPanelProps> = React.memo(
  ({
    size,
    material,
    position = [0, 0, 0] as [number, number, number],
    rotation = [0, 0, 0] as [number, number, number],
    radius,
    smoothness = 2,
    castShadow = false,
    receiveShadow = false,
  }) => {
    const r = radius ?? Math.min(size[0], size[1], size[2]) * 0.04;
    const args = useMemo(() => size, [size[0], size[1], size[2]]);

    return (
      <RoundedBox
        args={args}
        radius={Math.max(0.008, r)}
        smoothness={smoothness}
        position={position}
        rotation={rotation}
        castShadow={castShadow}
        receiveShadow={receiveShadow}
        material={material}
      />
    );
  }
);

BeveledPanel.displayName = 'BeveledPanel';

export default BeveledPanel;
